var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CCard',[_c('CCardHeader',[_c('CIcon',{attrs:{"name":"cil-vertical-align-bottom"}}),_c('h5',{staticClass:"d-inline ml-2"},[_vm._v("Menu Scraper")])],1),_c('CCardBody',[_c('Scraper')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }